import React, { SVGProps } from 'react';

const EllipsisWithExclamation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="22" cy="22" r="19" fill="#E08083" fill-opacity="0.2" />
    <circle cx="22" cy="22" r="22" fill="#E08083" fill-opacity="0.1" />
    <path
      d="M22 24.9687C21.5685 24.9687 21.2187 25.3185 21.2187 25.75C21.2187 26.1814 21.5685 26.5312 22 26.5312C22.4314 26.5312 22.7812 26.1814 22.7812 25.75C22.7812 25.3185 22.4314 24.9687 22 24.9687ZM22 23.25C22.3449 23.2498 22.6252 22.97 22.625 22.625V17.625C22.625 17.2798 22.3451 17 22 17C21.6548 17 21.375 17.2798 21.375 17.625V22.6257C21.3752 22.9707 21.655 23.2502 22 23.25ZM22 9.5C15.0965 9.5 9.5 15.0965 9.5 22C9.5 28.9035 15.0965 34.5 22 34.5C28.9002 34.4919 34.4919 28.9002 34.5 22C34.5 15.0965 28.9035 9.5 22 9.5ZM22 33.25C15.7868 33.25 10.75 28.2132 10.75 22C10.75 15.7868 15.7868 10.75 22 10.75C28.2104 10.7568 33.2432 15.7896 33.25 22C33.25 28.2132 28.2132 33.25 22 33.25Z"
      fill="#D6545E"
    />
  </svg>
);

export default EllipsisWithExclamation;
